import React from 'react';
import Totaliser from '../Totaliser/Totaliser';
import { FormattedMessage } from 'react-intl';
import styles from './RelatedStory.scss';

interface Props {
  id: string;
  percentage: number;
  owner: string;
  title: string;
  numberOfSupporters: number;
  totalRaised: number | string;
  pageImage: string;
  ownerAvatar: string;
  currencySymbol?: string;
  pageLink: string;
  onClick?: (id: string) => void;
  componentDidMountCallback?: (id: string) => void;
}

class RelatedStory extends React.Component<Props> {
  totaliser: HTMLElement | null;

  componentDidMount() {
    const { componentDidMountCallback, id } = this.props;

    if (componentDidMountCallback) {
      componentDidMountCallback(id);
    }
  }

  render() {
    const {
      id,
      title,
      owner,
      numberOfSupporters,
      totalRaised,
      pageImage,
      ownerAvatar,
      currencySymbol,
      pageLink,
      percentage,
      onClick,
    } = this.props;

    return (
      <div className="jg-width-100pc jg-height-100pc jg-bd jg-bd--solid jg-bd--very-light-grey jg-background--white">
        <a
          className={styles.card}
          href={pageLink}
          onClick={() => onClick && onClick(id)}
        >
          <div
            className={`${
              styles['related-story-image-container']
            } jg-width-100pc`}
          >
            <img
              className={`${styles['related-story-image']} jg-width-100pc`}
              src={pageImage}
            />
          </div>
          <div className="jg-space-pms">
            <h4 className={styles['project-title']}>{title}</h4>
            <div className="jg-display-flex jg-flex-aic jg-space-mbmd">
              <div className={styles['avatar-container']}>
                <img className={styles.avatar} src={ownerAvatar} />
              </div>
              <h5>{owner}</h5>
            </div>
            <div className="jg-display-flex">
              <Totaliser percentage={percentage} requestedSize="small" />
              <div className="jg-space-mlsm jg-flex-g1">
                <p className="jg-text--large">
                  <FormattedMessage
                    id="RelatedStory.amountRaisedBy"
                    defaultMessage="{amount} raised by"
                    values={{
                      amount: (
                        <span className="jg-text--brand">
                          {currencySymbol}
                          {totalRaised}
                        </span>
                      ),
                    }}
                  />
                </p>
                <p className="jg-text--large">
                  <FormattedMessage
                    id={`RelatedStory.${id}.supporterCount`}
                    defaultMessage="{supporterCount} {supporterCount, plural, one {supporter} other {supporters}}"
                    values={{
                      supporterCount: new Intl.NumberFormat([], {
                        maximumFractionDigits: 0,
                      }).format(numberOfSupporters),
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default RelatedStory;



// WEBPACK FOOTER //
// ./src/components/AlternativeProjects/RelatedStory.tsx